const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')
const Swal = require('../plugins/sweet/Alert').default

const buttonsModal = document.getElementsByClassName('buttonModal')
const buttonsShowLocation = document.getElementsByClassName('buttonShowLocation')
const buttonsVideo = document.getElementsByClassName('buttonVideo')

if (buttonsModal) {
  for (const button of buttonsModal) {
    button.addEventListener('click', () => {
      document.getElementById('imageInsideModal').setAttribute('src', button.getAttribute('data-image'))
    })
  }
}

if (buttonsShowLocation) {
  for (const button of buttonsShowLocation) {
    button.addEventListener('click', () => {
      document.getElementById('iframeLocation').setAttribute('src', button.getAttribute('data-ubicacionurl'))
    })
  }
}

if (buttonsVideo) {
  for (const button of buttonsVideo) {
    button.addEventListener('click', () => {
      document.getElementById('promotionalVideo').setAttribute('src', button.getAttribute('data-video'))
    })
  }
}

$('#modalVideo').on('hidden.bs.modal', function (event) {
  document.getElementById('promotionalVideo').pause()
})

const defaultSwal = {
  toast: true,
  timer: 2000,
  position: 'top-start',
  showConfirmButton: false,
  timerProgressBar: false,
}

listen('.linkSeleccionarModelo', 'click', function (e) {
  e.preventDefault()
  const trigger = e.delegateTarget || e.currentTarget
  const id = is.getAttributeValue(trigger, 'modeloproyectoid')
  document.getElementById(`submit-customer-purchase-${id}`).click()
})

const event = listen('input[id*="submit-customer-purchase-"]', 'click', function (e) {
  e.preventDefault()

  const trigger = e.delegateTarget || e.currentTarget
  trigger.disabled = true

  const span = is.make('span', { class: 'spinner-border spinner-border-sm' })
  trigger.appendChild(span)

  const id = is.getAttributeValue(trigger, 'id')
  const form = new FormData(document.getElementById(`form-customer-purchase-${id}`))
  const uri = is.getAttributeValue(trigger, 'action')
  const promise = Swal.axiosPost(form, uri)
  promise.then(response => {
    Swal.handleResult(true, { data: response.data ?? null, trigger }, 'success-send-data-buy-house')
  }).catch(error => {
    Swal.handleResult(false, { error, trigger }, 'error-send-data-buy-house')
  })
})

// Listeners
Swal.handleOn('success-send-data-buy-house', function (e) {
  const { params } = e
  const uriNext = is.getAttributeValue(params.trigger, 'next-action')
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'success',
    title: 'Datos enviados correctamente.',
  })
  params.trigger.innerHTML = '<strong class="text-uppercase">Comprar ahora</strong>'
  if (is.checkVariable(params.data)) {
    let redirect = null
    if (is.checkVariable(params.data.redirect)) {
      redirect = params.data.redirect
    } else {
      redirect = `${uriNext}/${params.data.precontratoId}`
    }

    is.waitInAWhile(defaultSwal.timer).then(() => {
      params.trigger.disabled = false
      event.destroy() // Destroy lifecycle.
      window.location.href = redirect
    })
  }
})
Swal.handleOn('error-send-data-buy-house', function (e) {
  const { params } = e
  const Toast = Swal.mixin(defaultSwal)
  Toast.fire({
    icon: 'error',
    title: 'Error al enviar los datos.',
  })
  params.trigger.disabled = false
  params.trigger.innerHTML = '<strong class="text-uppercase">Comprar ahora</strong>'
})
